import $ from 'jquery';
window.$ = window.jQuery = $;
import AOS from 'aos';
import gsap from 'gsap';
import "jquery-match-height/jquery.matchHeight";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import Lenis from '@studio-freight/lenis'
gsap.registerPlugin(ScrollTrigger);
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';
import '@fancyapps/fancybox';
import { default as fancybox } from '@fancyapps/fancybox';
import "@fortawesome/fontawesome-free/js/fontawesome.min";
import "@fortawesome/fontawesome-free/js/solid.min";
import "@fortawesome/fontawesome-free/js/regular.min";
import "@fortawesome/fontawesome-free/js/brands.min";

import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

import paper from 'paper';

//App imports

import {menuMain} from "./menu";

import SplitType from 'split-type'
/****************************************************************************
 * Theme scripts.
 ****************************************************************************/


window.addEventListener('load', function() {
    AOS.refresh();
});


(function( $ ){
    'use strict';

    setTimeout( () => {

        $('.js-mobile-trigger').on('click', function(){
            $('body').toggleClass('active-menu');
        })

        $('.js-play-video').on('click', function(){
            $(this).parent().find('img').animate({
                opacity: 0
            }, 500)
            $(this).animate({
                opacity: 0
            }, 500)

            $(this).parent().parent().addClass('playing')

            var video = $("#myVideo")[0]; // Get the video element
            if (video.paused) {
                // If the video is paused, play it
                video.play();
            } else {
                // If the video is playing, pause it
                video.pause();
            }
        })

        $('.js-pause-video').on('click', function(){
            $(this).parent().find('img').animate({
                opacity: 1
            }, 500)
            $(this).animate({
                opacity: 1
            }, 500)
            $('.js-play-video').animate({
                opacity: 1
            }, 500)
            $(this).animate({
                opacity: 0
            }, 500)
            $(this).parent().parent().removeClass('playing')

            var video = $("#myVideo")[0]; // Get the video element
            if (video.paused) {
                // If the video is paused, play it
                video.play();
            } else {
                // If the video is playing, pause it
                video.pause();
            }
        })

        AOS.init({  duration: 1200 });
        const myText = new SplitType('#myText');

        const tl1 = gsap.timeline();

        var char = $('#myText').find('.char');

            tl1.to(char,{
                y: 0,
                stagger: 0.05,
                delay: 0.2,
                duration: 0.1,
                opacity:1
            })

        var h1 = new SplitType('.h1');
        var subtitle = new SplitType('.subtitle');
        var general = new SplitType('.general-content h2');
        var generalh3 = new SplitType('.general-content h3');


        $('[data-block] .subtitle').each(function() {
            // Prepare the timeline for each .h1
            let tl1 = gsap.timeline({
                scrollTrigger: {
                    trigger: this,
                    start: "top 100%", // Start animation as soon as any part of the element comes into view
                    end: 'bottom top',

                }
            });
            var target = $(this).parent().find('.char')
            tl1.to(target,{
                y: 0,
                stagger: 0.05,
                delay: 0.2,
                duration: 0.1,
                opacity:1
            })
        });

        $('.general-content h3').each(function() {
            // Prepare the timeline for each .h1
            let tl1 = gsap.timeline({
                scrollTrigger: {
                    trigger: this,
                    start: "top 100%", // Start animation as soon as any part of the element comes into view
                    end: 'bottom top',

                }
            });
            var target = $(this).parent().find('.char')
            tl1.to(target,{
                y: 0,
                stagger: 0.05,
                delay: 0.2,
                duration: 0.1,
                opacity:1
            })
        });


        gsap.to(".my-image", {
            scrollTrigger: {
                trigger: ".my-image",
                start: "top bottom",
                end: "bottom top",
                scrub: true,
                onUpdate: self => {
                    // scale goes from 1 to 1.2 as we scroll through the element
                    gsap.set(".my-image", { y:-10, scale: 1 + (0.2 * self.progress) });
                }
            }
        });

        gsap.to(".big-image", {
            scrollTrigger: {
                trigger: ".big-image",
                start: "top bottom",
                end: "bottom top",
                scrub: true,
                onUpdate: self => {
                    // scale goes from 1 to 1.2 as we scroll through the element
                    gsap.set(".big-image", { y:-10, scale: 1 + (0.2 * self.progress) });
                }
            }
        });


        var swiper = new Swiper('.gallerySlider', {
            // Other options...
            navigation: {
                nextEl: '.custom-arrow-next',
                prevEl: '.custom-arrow-prev',
            },
        });




    }, 400 );

    setTimeout( () => {

        // scroll.update();

    }, 2000 );

    $(window).on('scroll', function (event) {
        AOS.refresh();
    });


} )( jQuery );

$(function(){



})



function scrollVideo() {
    var video = $('#video').get(0),
        videoLength = video.duration,
        scrollPosition = $(document).scrollTop();

    video.currentTime = (scrollPosition / ($(document).height() - $(window).height())) * videoLength;
}

$(window).scroll(function(e) {
    scrollVideo();
});


/***************
 * After theme scripts
 ***************/
// // Each time the window updates, refresh ScrollTrigger and then update LocomotiveScroll
// ScrollTrigger.addEventListener( 'refresh', () => scroll.update() );
//
// // After everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
// ScrollTrigger.refresh();